import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import { UserForm } from "../../Users/UserForm";

import { useVenueUserCreateForm } from "./hooks";

const VenueUserCreate: React.FC = () => {
  const form = useVenueUserCreateForm();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create new User" />
        </Typography.Title>
      </Header>
      <Space />
      <UserForm {...form} />
    </>
  );
};

export default VenueUserCreate;
